"use strict";

import router from 'router';

export const reverseRoute = (name) => {
  const { location } = router.resolve(name);
  return location.path;
};



// WEBPACK FOOTER //
// ./client/services/router.js